import React, { useCallback, useState } from 'react';

import { Box, Layout, Page, Stack } from 'src/components/matchbox';
import { ExternalLink, PageLink, SubduedLink } from 'src/components/links';
import { Tabs } from 'src/components';
import AlertIncidents from './IncidentsTable';
import { alert as data, incidents } from './mock';
import AlertOverView from './AlertOverview';
import { Heading } from 'src/components/text';

import AlertDetails from './AlertDetails';
// TODO: Implement once API is ready
// import { useSparkPostQuery } from 'src/hooks';
// import { getAlert } from 'src/helpers/api/alerts';
// import { useParams } from 'react-router-dom';

const backBreadcrumb = { content: 'Alerts', to: '/alerts', as: PageLink };

const tabs = [{ content: 'Incident History' }, { content: 'Alert Overview' }];

const TAB_OVERVIEW_AND_HISTORY = 0;
const TAB_ALERT_HISTORY = 1;

export default function NewDetailsPage() {
  const [selectedTab, setSelectedTab] = useState(TAB_OVERVIEW_AND_HISTORY);

  const showDetailsSection = selectedTab === TAB_ALERT_HISTORY;

  const selectTab = useCallback((tab) => {
    setSelectedTab(tab);
  }, []);
  // const { id } = useParams();
  // const { data, status } = useSparkPostQuery(() => getAlert(id));
  const status = 'success';

  return (
    <Page title="Alert Details" breadcrumbAction={backBreadcrumb}>
      <Tabs tabs={tabs} onSelect={selectTab} selected={selectedTab} mb="500" />
      <Box>
        <Layout>
          {showDetailsSection && (
            <Layout.Section annotated>
              <Stack>
                <Heading as="h4">Details</Heading>
                <SubduedLink
                  as={ExternalLink}
                  to="https://support.sparkpost.com/docs/user-guide/alerts/"
                >
                  Alert Documentation
                </SubduedLink>
              </Stack>
            </Layout.Section>
          )}
          <AlertDetails
            alert={data}
            loading={status === 'loading'}
            showDetailsSection={showDetailsSection}
          />
        </Layout>
        {selectedTab === TAB_OVERVIEW_AND_HISTORY && (
          <AlertIncidents
            alert={data}
            placeholder="e.g. Sparky’s Cookie Co. or monthly-newsletter"
            incidents={incidents}
          />
        )}
        {selectedTab === TAB_ALERT_HISTORY && <AlertOverView alert={data} />}
      </Box>
    </Page>
  );
}
